export const tokens = {
  color: {
    primary:        '#1f425a',
    primaryDarken:  '#163349',
    accent:         '#eb6622',
    scrim:          '#1f425a',
    surface:        '#ffffff',
    surfaceVariant: '#f6f7f9',
    onSurface:        'rgba(0,0,0,.87)',
    onSurfaceVariant: 'rgba(0,0,0,.62)',
    outline:        'rgba(0,0,0,.12)',
    outlineVariant: 'rgba(0,0,0,.06)',
    outlineStrong:  'rgba(0,0,0,.12)',
    info:    '#2196f3',
    success: '#4caf50',
    warning: '#fb8c00',
    danger:  '#ff5252',
    primaryText: '#1f425a',
    accentText:  '#eb6622',
    infoText:    '#2196f3',
    successText: '#4caf50',
    warningText: '#fb8c00',
    dangerText:  '#ff5252',
    onPrimary: '#ffffff',
    onAccent:  '#000000',
    onInfo:    '#000000',
    onSuccess: '#000000',
    onWarning: '#000000',
    onDanger:  '#000000',
    primaryTint:       '#ebf2fa',
    primaryTintStrong: '#d8e6f5',
    cardinalityAtLeast:     '#69aed5',
    cardinalityAtLeastTint: '#ebf2fa',
    cardinalityAtLeastText: '#336b91',
    cardinalityAtLeastChipText: '#4a90ba',
    cardinalityExactly:     '#2e7d32',
    cardinalityExactlyTint: '#e8f5e9',
    cardinalityExactlyText: '#2e7d32',
    cardinalityAtMost:      '#336b91',
    cardinalityAtMostTint:  '#e3ecf3',
    cardinalityAtMostText:  '#336b91',
  },
  colorDark: {
    primary:        '#6aa3cb',
    primaryDarken:  '#4f86ad',
    accent:         '#eb6622',
    scrim:          '#000000',
    surface:        '#161618',
    surfaceVariant: '#0a0a0b',
    onSurface:        '#f4f4f5',
    onSurfaceVariant: '#a1a1aa',
    outline:        'rgba(255,255,255,.14)',
    outlineVariant: 'rgba(255,255,255,.07)',
    outlineStrong:  'rgba(255,255,255,.36)',
    info:    '#4aa3f0',
    success: '#5cc16a',
    warning: '#ffa726',
    danger:  '#ff6b6b',
    primaryText: '#6aa3cb',
    accentText:  '#eb6622',
    infoText:    '#4aa3f0',
    successText: '#5cc16a',
    warningText: '#ffa726',
    dangerText:  '#ff6b6b',
    onPrimary: 'rgba(0,0,0,.87)',
    onAccent:  'rgba(0,0,0,.87)',
    onInfo:    'rgba(0,0,0,.87)',
    onSuccess: 'rgba(0,0,0,.87)',
    onWarning: 'rgba(0,0,0,.87)',
    onDanger:  'rgba(0,0,0,.87)',
    primaryTint:       'color-mix(in srgb, #6aa3cb 14%, #161618)',
    primaryTintStrong: 'color-mix(in srgb, #6aa3cb 24%, #161618)',
    cardinalityAtLeast:     '#4aa3f0',
    cardinalityAtLeastTint: 'color-mix(in srgb, #4aa3f0 14%, #161618)',
    cardinalityAtLeastText: '#4aa3f0',
    cardinalityAtLeastChipText: '#4aa3f0',
    cardinalityExactly:     '#5cc16a',
    cardinalityExactlyTint: 'color-mix(in srgb, #5cc16a 14%, #161618)',
    cardinalityExactlyText: '#5cc16a',
    cardinalityAtMost:      '#6aa3cb',
    cardinalityAtMostTint:  'color-mix(in srgb, #6aa3cb 14%, #161618)',
    cardinalityAtMostText:  '#6aa3cb',
  },
  radius:  { sm: '4px', md: '8px', lg: '12px', xl: '16px' },
  spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
  density: { default: 'compact' as const },
  elevation: {
    ambient: '0 1px 3px rgba(15,23,42,.08)',
    diffuse: '0 8px 24px rgba(15,23,42,.08)',
    hover:   '0 2px 6px rgba(15,23,42,.1), 0 12px 32px rgba(15,23,42,.12)',
  },
  motion:  { fast: '120ms ease', med: '160ms ease', slow: '240ms ease' },
  z:       { dropdown: 1000, dialog: 2000, snackbar: 3000 },
} as const

export type AtlasTokens = typeof tokens
